<template>
  <div class="content">
    <div :class="{bg: true,empty: list.length === 0}">
      <div class="filters">
        <div class="filter">
          <div class="title">
            {{depData.title}}
          </div>
          <multiFilter :filter="depData.list" @getData="getDep" />
          <div class="searchBtn greenBtn" @click="startSearch">
            <img src="@assets/img/common/static.svg" alt="static">
            <span>统计搜索</span>
          </div>
        </div>
        <div class="filter">
          <p class="title">
            报片日期
          </p>
          <date-picker v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker>
        </div>
      </div>
      <div class="list">
        <empty :mTop="50" :msg="'暂无报片数据，请进行筛选后搜索'" v-if="list && list.length === 0" />
        <div v-else>
          <div class="statics">
            <div class="info">
              <p class="part">总报片数：<span class="green">{{statics.total}}</span> 条</p>
              <p class="part">总电视播出：<span class="green">{{statics.used}}</span> 条</p>
              <p class="part">总采用率：<span class="green">{{statics.rate}}</span></p>
            </div>
            <div class="btns">
              <div class="searchBtn ml10" @click="refresh">
                <img src="@assets/img/resources/fresh.svg" alt="fresh">
                <span>刷新</span>
              </div>
              <div class="searchBtn greenBtn ml10" @click="exportRes">
                <img src="@assets/img/resources/export.svg" alt="fresh">
                <span>导出</span>
              </div>
            </div>
          </div>
          <div class="tableLine">
            <span class="item">部门</span>
            <span class="item">报片数</span>
            <span class="item">电视播出数</span>
            <span class="last">采用率</span>
          </div>
          <div class="li" v-for="(i, d) in list" :key="d">
            <div class="item title" @click="showDepDetail(i)">
              {{i.depart_title}}
            </div>
            <div class="item" @click="showDepDetail(i)">
              <p class="rep">
                {{i.report_num}}
              </p>
            </div>
            <div class="item" @click="showDepDetail(i, '0')">
              <p class="use">
                {{i.use_num}}
              </p>
            </div>
            <div class="last" @click="showDepDetail(i)">{{i.use_pre}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="pop" v-show="depDetail.show">
      <div class="depContent">
        <div class="headline">
          <div class="title">
            {{depDetail.title || '部门名'}}
          </div>
          <img src="@assets/img/resources/close.svg" alt="close" class="close" @click="depDetail.close()">
        </div>
        <div class="statusLine">
          <div class="status">
            <div class="title">
              {{depDetail.filters.title || '标题'}}
            </div>
            <div :class="{item: true, active: l.selected}" v-for="(l, i) in depDetail.filters.list" :key="i" @click="depDetail.selectFilter(l)">{{l.title}}</div>
          </div>
          <div class="statics">
            <p class="part">总报片数：<span class="green">{{depDetail.statics.total}}</span> 条</p>
            <p class="part">总电视播出：<span class="green">{{depDetail.statics.used}}</span> 条</p>
            <p class="part">总采用率：<span class="green">{{depDetail.statics.rate}}</span></p>
          </div>
        </div>
        <div class="tableLine">
          <span class="name">稿件名称</span>
          <span class="reporters">记者</span>
          <span class="camera">摄像</span>
          <span class="supply">供片</span>
          <span class="show">播出栏目</span>
          <span class="btime">播出时间</span>
          <span class="ptime">发布时间</span>
        </div>
        <div class="list" ref="depDetailList">
          <empty :msg="'暂无报片数据'" v-if="depDetail.list && depDetail.list.length === 0" />
          <div :class="{item: true, greenBg: l.has_use}" v-for="(l, i) in depDetail.list || []" :key="i">
            <p class="name" @click="depDetail.goReport(l)">{{l.title}}</p>
            <p class="reporters">{{l.reporters}}</p>
            <p class="camera">{{l.cameras}}</p>
            <p class="supply">{{l.depart_title}}</p>
            <p class="show">
              <span v-for="(u, d) in l.use_log" :key="d">{{u.type_name}}</span>
            </p>
            <p class="btime">
              <span v-for="(u, d) in l.use_log" :key="d">{{u.release_time}}</span>
            </p>
            <p class="ptime">
              {{l.raw_update_time}}
            </p>
          </div>
        </div>
        <div class="footer">
          <div class="searchBtn greenBtn" @click="depDetail.exportRes">
            <img src="@assets/img/resources/export.svg" alt="fresh">
            <span>导出</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'
import multiFilter from '@components/multiFilter'

export default {
  name: 'tv',  // 数据中心-电视报片
  components: {
    DatePicker, empty, multiFilter
  },
  data() {
    return {
      list: [],
      statics: {
        total: 0,
        used: 0,
        rate: '0%'
      },
      datePicker: [],
      depData: {
        title: '',
        list: []
      },
      filterOptions: {},
      depDetail: { // 部门详情数据模型
        show: false,
        id: '',
        title: '',
        list: [],
        open: (dep, s) => {
          this.depDetail.id = dep.id
          this.depDetail.title = dep.title
          this.depDetail.getList(s)
          this.depDetail.show = true

          setTimeout(() => {
            this.depDetail.handleScroll()
          }, 0)
        },
        close: () => {
          this.depDetail.id = ''
          this.depDetail.title = ''
          this.depDetail.list = null
          this.depDetail.filters = {
            key: '',
            title: '',
            list: []
          }
          this.depDetail.page = {
            pageIndex: 1,
            pageSize: 10,
            pageCount: 10
          }
          this.depDetail.statics = {
            total: 0,
            used: 0,
            rate: 0
          }
          
          this.depDetail.show = false
        },
        selectFilter:(i) => {
          this.depDetail.filters.list.forEach(l => {
            l.selected = false
          })

          this.$nextTick(() => {
            this.$set(i, 'selected', true)
            this.depDetail.list = null
            this.depDetail.page.pageIndex = 1
            this.depDetail.page.pageCount = 10
            this.depDetail.getList()
          })
        },
        getList: (s = '') => {
          this.depDetail.scrollLock = true
          if (this.depDetail.page.pageCount && this.depDetail.page.pageIndex > this.depDetail.page.pageCount) return

          const info = {
            depart_id: this.depDetail.id,
            start: this.filterOptions.start,
            end: this.filterOptions.end,
            status: s || (this.depDetail.filters.list.filter(i => i.selected)[0] ? this.depDetail.filters.list.filter(i => i.selected)[0].key : ''),
            page: this.depDetail.page.pageIndex,
            pagesize: this.depDetail.page.pageSize,
            page_type:  0
          }

          common.myFetch(apis.data_tv_detail, info)
          .then((r) => {
            if (r) {
              this.depDetail.list = (this.depDetail.list || []).concat(r.list || [])
              this.depDetail.filters = r.params.list_search[0] || {}
              this.depDetail.statics = {
                total: r.total_report_num,
                used: r.total_use_num,
                rate: r.total_use_pre
              }
              this.depDetail.page.pageIndex += 1
              this.depDetail.page.pageCount = r.page.page_count
              this.depDetail.scrollLock = false
            }
          })
        },
        exportRes: () => {
          const info = {
            depart_id: this.depDetail.id,
            start: this.filterOptions.start,
            end: this.filterOptions.end,
            status: this.depDetail.filters.list.filter(i => i.selected)[0] ? this.depDetail.filters.list.filter(i => i.selected)[0].key : '',
            page: this.depDetail.page.pageIndex,
            pagesize: this.depDetail.page.pageSize,
            page_type: 1
          }
          const userKeys = common.userKeys()
          const params = Object.assign({}, info, userKeys)
          const url = apis.data_tv_detail
          
          common.exportRes(url, params)
        },
        goReport: (l) => {
          if (!l.has_detail_role) {
            this.$toast('无访问权限')
            return
          }

          const newWindow = window.open()

          newWindow.location.href = `${window.location.origin}/reportDetail?d=${l.id}`
        },
        filters: {
          key: '',
          title: '',
          list: []
        },
        filterOptions: {
          page_type: 0
        },
        statics: {
          total: 0,
          used: 0,
          rate: 0
        },
        page: {
          pageIndex: 1,
          pageSize: 10,
          pageCount: 10
        },
        scrollLock: false,
        handleScroll: () => {
          const container = this.$refs.depDetailList
          container.addEventListener('scroll', () => {
            const scrolltop = container.scrollTop;
            const scrollheight = container.scrollHeight;
            const clientheight = container.clientHeight;

            if (scrolltop + clientheight >= scrollheight) {
              if (this.depDetail.scrollLock) return
              this.depDetail.getList()
            }
          }, false)
        }
      }
    }
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function(n, o) {
        this.filterOptions['start'] = this.getDayStart(n[0])
        this.filterOptions['end'] = this.getDayEnd(n[1])
      }
    }
  },
  methods: {
    startSearch() {
      // 统计搜索事件
      if (!this.filterOptions.start || !this.filterOptions.end) {
        this.$toast('报片日期不能为空')
        return
      }

      this.filterOptions.page_type = 1

      this.getList()
    },
    showDepDetail(d, s) {
      this.depDetail.open({
        id: d.depart_id,
        title: d.depart_title
      }, s)
    },
    getDayEnd(s) {
      // 获取当天的结束时间
      if (!s) {
        return ''
      }

      const year = s.getFullYear()
      const month = common.doubleDigit(s.getMonth() + 1)
      const day = common.doubleDigit(s.getDate())

      return  `${year}-${month}-${day} 23:59:59`
    },
    getDayStart(s) {
      // 获取当天的开始时间
      if (!s) {
        return ''
      }

      const year = s.getFullYear()
      const month = common.doubleDigit(s.getMonth() + 1)
      const day = common.doubleDigit(s.getDate())

      return  `${year}-${month}-${day} 00:00:00`
    },
    getList() {
      //  获取列表数据
      const id = this.$route.params.id
      const info = {
        idstring: id,
        start: this.filterOptions['start'] || '',
        end: this.filterOptions['end'] || '',
        depart_id: this.filterOptions['depart_id'] || '',
        depart_son_id: this.filterOptions['depart_son_id'] || '',
        page_type: this.filterOptions['page_type'] || ''
      }

      common.myFetch(apis.data_tv, info)
      .then((data) => {
        if (data) {
          this.list = data.list
          this.depData = {
            title: data.params.list_search.filter(i => i.key === 'depart_id')[0].title || '部门',
            list: data.params.list_search.filter(i => i.key === 'depart_id')[0].list || []
          }
          this.statics = {
            total: data.total_report_num,
            used: data.total_use_num,
            rate: data.total_use_pre
          }
        }
      })
    },
    getDep(data) {
      // 获取部分选择数据
      this.filterOptions['depart_id'] = data.one.key
      this.filterOptions['depart_son_id'] = data.two.key
    },
    refresh() {
      // 刷新
      this.filterOptions.page_type = 1

      this.getList()
    },
    exportRes() {
      // 导出列表
      this.filterOptions.page_type = 2

      const info = {
        start: this.filterOptions['start'] || '',
        end: this.filterOptions['end'] || '',
        depart_id: this.filterOptions['depart_id'] || '',
        depart_son_id: this.filterOptions['depart_son_id'] || '',
        page_type: this.filterOptions['page_type'] || ''
      }
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys)
      const url = apis.data_tv
      
      common.exportRes(url, params)
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style lang="less" src="@assets/css/data/tv.less" scoped></style>
